import { SectionHeading } from './SectionHeading'

const CATEGORIES = [
  { label: 'ユースケース', description: '実装できる案件の事例' },
  { label: 'ノウハウ', description: '発注前に知りたい実情' },
  { label: 'トレンド', description: '業界動向を発注側目線で' },
  { label: 'ニュース', description: '今週のAIを3行で' },
  { label: '用語解説', description: 'たとえ話で噛み砕く' }
]

export function Articles() {
  return (
    <section
      id="articles"
      className="section-wrapper relative overflow-hidden bg-brand-gray"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-brand-gray via-slate-50 to-blue-50/30" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="AI for Business" title="ビジネスとAI" />

        <div className="max-w-5xl mx-auto animate-on-scroll bg-white border border-slate-100 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300">
          <div className="p-8 md:p-12">
            <div className="mb-8">
              <p className="text-brand-cyan text-xs font-semibold tracking-[0.2em] uppercase mb-3">
                AI INSIGHTS FOR BUSINESS
              </p>
              <h3 className="text-xl md:text-2xl font-bold text-brand-navy mb-4 leading-snug">
                AI活用の判断材料を、わかりやすく。
              </h3>
              <p className="text-brand-navy/70 text-sm md:text-base leading-relaxed">
                「AIをビジネスに取り入れたいが、自社で何ができるのか見極めたい」——
                そんな方に向けて、当社が運営する情報サイトです。
                AIで実現できること、他社の活用事例、押さえておきたい動向などを、
                専門用語をできる限り避け、簡潔に読める記事にまとめてお届けしています。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-10">
              {CATEGORIES.map((c, i) => (
                <div
                  key={c.label}
                  className={`animate-on-scroll animate-on-scroll-delay-${(i % 5) + 1} px-3 py-4 rounded-xl bg-slate-50 border border-slate-100 text-center hover:border-brand-cyan/40 hover:bg-white transition-all duration-300`}
                >
                  <div className="text-sm font-semibold text-brand-navy mb-1">
                    {c.label}
                  </div>
                  <div className="text-[11px] text-brand-navy/50 leading-tight">
                    {c.description}
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center animate-on-scroll animate-on-scroll-delay-1">
              <a
                href="https://articles.jfrontier.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                AI活用記事を読む
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2.5}
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
